import { ProductType } from '@/AppGlobal';
import { EddaBankInfo } from '@/interface/KKC/edda';
import {
  AppPayOrderBillDTO,
  AppPayOrderDetailDTO,
  LoanDto,
  LoanDtoSchedule,
  RepayImmediateResult,
  RepaymentBillFlushRecordDto,
} from '@/interface/KKC/repayment';
import { ListTabType } from '@/pages/KKC/repayment/subpages/RepaymentList';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  loanDto: LoanDto | null | LoanDtoSchedule;
  repaymentNo: string;
  repayImmediateResult: RepayImmediateResult | null;
  appPayOrderDetailDto: AppPayOrderDetailDTO | null;
  appPayOrderBillDto: AppPayOrderBillDTO | null;
  bankInRepayNow: EddaBankInfo | null; // 立即还款中选中的银行，成功结果页中展示
  otherFiles: RepaymentBillFlushRecordDto[];
  refundCommission: RepaymentBillFlushRecordDto[];
  repaymentListTabCache: {
    productTab: ProductType | null;
    listTab: ListTabType | null;
  };
}

const initialState: CommonState = {
  loanDto: null,
  repaymentNo: '',
  repayImmediateResult: null,
  appPayOrderDetailDto: null,
  appPayOrderBillDto: null,
  bankInRepayNow: null,
  otherFiles: [],
  refundCommission: [],
  repaymentListTabCache: {
    productTab: null,
    listTab: null,
  },
};

const repaymentSlice = createSlice({
  name: 'repaymentStore',
  initialState,
  reducers: {
    setLoanDtoFromRepment(
      state: CommonState,
      action: PayloadAction<{ loanDto: LoanDto | LoanDtoSchedule }>
    ) {
      state.loanDto = action.payload.loanDto;
    },
    setRepaymentNo(state: CommonState, action: PayloadAction<{ repaymentNo: string }>) {
      state.repaymentNo = action.payload.repaymentNo;
    },
    setRepayImmediateResult(
      state: CommonState,
      action: PayloadAction<{ repayImmediateResult: RepayImmediateResult }>
    ) {
      state.repayImmediateResult = action.payload.repayImmediateResult;
    },
    setAppPayOrderDetailDTO(
      state: CommonState,
      action: PayloadAction<{ appPayOrderDetailDto: AppPayOrderDetailDTO }>
    ) {
      state.appPayOrderDetailDto = action.payload.appPayOrderDetailDto;
    },
    setAppPayOrderBillDto(
      state: CommonState,
      action: PayloadAction<{ appPayOrderBillDto: AppPayOrderBillDTO }>
    ) {
      state.appPayOrderBillDto = action.payload.appPayOrderBillDto;
    },
    setBankInRepayNow(state: CommonState, action: PayloadAction<{ bankInRepayNow: EddaBankInfo }>) {
      state.bankInRepayNow = action.payload.bankInRepayNow;
    },
    setOtherFiles(state: CommonState, action: PayloadAction<RepaymentBillFlushRecordDto[]>) {
      state.otherFiles = action.payload;
    },
    setRefundCommissions(state: CommonState, action: PayloadAction<RepaymentBillFlushRecordDto[]>) {
      state.refundCommission = action.payload;
    },
    clearOtherFiles(state: CommonState) {
      state.otherFiles = [];
    },
    clearBankInRepayNow(state: CommonState) {
      state.bankInRepayNow = null;
    },
    clearLoanDtoFromRepment(state: CommonState) {
      state.loanDto = null;
    },
    clearRepaymentNo(state: CommonState) {
      state.repaymentNo = '';
    },
    clearRepayImmediateResult(state: CommonState) {
      state.repayImmediateResult = null;
    },
    clearAppPayOrderDetailDTO(state: CommonState) {
      state.appPayOrderDetailDto = null;
    },
    setRepaymentListTabCache(
      state: CommonState,
      action: PayloadAction<{ productTab: ProductType | null; listTab: ListTabType | null }>
    ) {
      state.repaymentListTabCache = action.payload;
    },
  },
});

const {
  setLoanDtoFromRepment,
  clearLoanDtoFromRepment,
  setRepaymentNo,
  clearRepaymentNo,
  setRepayImmediateResult,
  clearRepayImmediateResult,
  setAppPayOrderDetailDTO,
  setAppPayOrderBillDto,
  clearAppPayOrderDetailDTO,
  setBankInRepayNow,
  clearBankInRepayNow,
  setOtherFiles,
  clearOtherFiles,
  setRefundCommissions,
  setRepaymentListTabCache,
} = repaymentSlice.actions;

export {
  clearAppPayOrderDetailDTO,
  clearBankInRepayNow,
  clearLoanDtoFromRepment,
  clearRepayImmediateResult,
  clearRepaymentNo,
  setAppPayOrderDetailDTO,
  setAppPayOrderBillDto,
  setBankInRepayNow,
  setLoanDtoFromRepment,
  setRepayImmediateResult,
  setRepaymentNo,
  setOtherFiles,
  clearOtherFiles,
  setRefundCommissions,
  setRepaymentListTabCache,
};

export default repaymentSlice.reducer;
